import './NotFound.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NOT_FOUND_TYPES_PROJECT } from '../../constants/notFoundTypes'

class NotFound extends Component {
  mapNotFoundMessage = (notFoundType) => {
    let message = ''
    switch (notFoundType) {
      case NOT_FOUND_TYPES_PROJECT:
        message = this.props.localize('taskBoards.Msg_WorkspaceNotFoundForBoard')
        break
      default:
        message = this.props.localize('taskBoards.Msg_PageNotFound')
    }

    return message
  }
  render() {
    const message = this.mapNotFoundMessage(this.props.params.notFoundType)
    return (
      <div className='not-found-message-container'>
        {message}
      </div>
    )
  }
}

NotFound.propTypes = {
  localize: PropTypes.func.isRequired
}

export default NotFound



// WEBPACK FOOTER //
// ./src/routes/NotFound/NotFound.js